import React from "react";
import { Card, CardContent, Typography, Button, Box, Divider } from "@mui/material";
import "./ICICIBanking.css";
import iciciLogo from "../../.././assets/images/icic.png";

const ICICIBanking = () => {
  return (
    <Card className="icici-card">
      <CardContent>
        {/* Header */}
        <Box className="icici-header">
          <Typography className="icici-title" variant="h6">
            <img
              src={iciciLogo}
              alt="ICICI Logo"
              className="icici-logo"
            />
            ICICI Bank Business Banking
          </Typography>
          <Button variant="outlined" className="icici-refresh-btn">
            Refresh Status
          </Button>
        </Box>

        <Divider className="icici-divider" />

        {/* Description */}
        <Typography className="icici-description">
          Setup your ICICI Account with Kredily and pay your employees with a single click.
        </Typography>

        {/* Account Info */}
        <Box className="icici-account-info">
          <Typography>
            <strong>Account Status:</strong> REGISTERED
          </Typography>
          <Typography>
            <strong>Corp ID:</strong> 528888826
          </Typography>
          <Typography>
            <strong>User ID:</strong> USER1
          </Typography>
        </Box>

        <Divider className="icici-divider" />

        {/* Selected Account */}
        <Box className="icici-selected-account">
          <Typography className="icici-subtitle">Selected Account</Typography>
          <Typography>
            <strong>Account Title:</strong> ENVISION INTEGRATED SERVICES PRIVATE LIMITED
          </Typography>
          <Typography>
            <strong>Account Number:</strong> 631205500365
          </Typography>
        </Box>

        <Divider className="icici-divider" />

        <Button variant="text" className="icici-change-btn">
          Change account for making payments
        </Button>
      </CardContent>
    </Card>
  );
};

export default ICICIBanking;
